import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomHandler<{ahriSystemToolPageSize:number}>

export const DispatchAHRISystemToolPageSize: HandlerType = props =>{
    props.dispatch({
        type:"Custom/AHRISystemToolConfigPagination/PageSize",
        pageSize:props.parameter.ahriSystemToolPageSize
    })
}

export const chain = [DispatchAHRISystemToolPageSize];

const AHRISystemToolPageSizeHandler = createHandlerChainRunner(chain,"PageSize");
export default AHRISystemToolPageSizeHandler;